/**
 * Default page title for the admin app
 */
const DEFAULT_TITLE = "CampusIQ Admin"

/**
 * Map of route IDs to human-readable page titles.
 * Keys match the route IDs from NAVIGATION_OPTION_IDS and DROPDOWN_OPTION_IDS in App.js.
 */
const ROUTE_TITLES = {
  map: "Map",
  dashboard: "Dashboard",
  adminDashboard: "Admin Dashboard",
  school: "Institution",
  wireless_config: "Wireless Config",
  file_upload: "File Upload",
  alert: "Alerts",
  spark: "Spark",
}

/**
 * Get the page title for a given route ID.
 *
 * @param {string|null} routeId - The current route ID from getCurrentId()
 * @returns {string} The page title in format "View Name - CampusIQ Admin"
 */
export function getRouteTitle(routeId) {
  const label = ROUTE_TITLES[routeId]
  if (!label) return DEFAULT_TITLE
  return `${label} - ${DEFAULT_TITLE}`
}
